import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import studentReducer from "../features/students/studentSlice";
import officeReducer from "../features/location/officeSlice";
import schoolReducer from "../features/school/schoolSlice";
import officeWeekReducer from "../features/week/officeWeekSlice";
import genderReducer from "../features/gender/genderSlice"
import { persistReducer, persistStore } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

//redux persist config - auth state blacklisted (we don't want user details in session storage)
const persistBaseConfig = {
  key: "root",
  storage: storageSession,
  blacklist: ["auth"],
};

//redux reducers
const rootReducer = combineReducers({
  auth: authReducer,
  student: studentReducer,
  office: officeReducer,
  officeWeek: officeWeekReducer,
  school: schoolReducer,
  gender: genderReducer,
});

//combine reducers into persist reducer
const persistedReducer = persistReducer(persistBaseConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
